/**
 * La entrada al Editor Studio: una cuenta, no una contraseña de este ordenador.
 *
 * DESDE EL 11-sep-2026. Va por delante del candado local de `Puerta.tsx`, que no se podía
 * recuperar porque vivía solo en el disco. La cuenta la guarda Clerk —email y contraseña o Google,
 * con recuperación de verdad—. Y lo que NO cambia se dice aquí mismo, porque es lo que el autor
 * compra: la cuenta sabe quién eres, no lo que escribes. El manuscrito sigue en tu ordenador.
 */
import { SignIn } from "@clerk/react";

export default function Entrada() {
  return (
    <div className="puerta">
      <section className="carta">
        <div className="marca">
          <img src="/humanink.png" alt="" width="26" height="26" />
          <b>HumanInk</b><span>Editor Studio</span>
        </div>
        <h2>Entra en tu estudio<span className="sub">con tu cuenta</span></h2>
        <p className="vacio">
          Tu cuenta sabe quién eres, no lo que escribes: <b>el manuscrito no sale de tu
          ordenador</b>. Entra con tu email o con Google; si olvidas la contraseña, se recupera
          desde aquí.
        </p>
        {/* Sin enrutador en el Studio: el formulario lleva sus pasos en el hash de la URL. */}
        <SignIn routing="hash" />
      </section>
    </div>
  );
}
